import { CheckCircle2, Hammer, Compass } from "lucide-react";

/**
 * Public marketing status badge for feature capability states.
 * Three states only, matching the Boat Club brief:
 *   - "available"      → live today      (default/baseline)
 *   - "in_development" → actively being built next
 *   - "roadmap"        → planned, not scheduled
 *
 * Visual weight is DELIBERATELY ordered: available is most prominent,
 * roadmap is the quietest. Never flip these.
 */
const VARIANTS = {
  available: {
    label: "Available Now",
    cls: "bg-emerald-50 text-emerald-800 border-emerald-200",
    Icon: CheckCircle2,
    testid: "feature-status-available",
  },
  in_development: {
    label: "In Development",
    cls: "bg-amber-50 text-amber-900 border-amber-200",
    Icon: Hammer,
    testid: "feature-status-in-development",
  },
  roadmap: {
    label: "Roadmap",
    cls: "bg-slate-100 text-slate-600 border-slate-200",
    Icon: Compass,
    testid: "feature-status-roadmap",
  },
};

export default function FeatureStatusBadge({ status = "available", size = "sm", className = "" }) {
  const v = VARIANTS[status] || VARIANTS.available;
  const Icon = v.Icon;
  const sizing =
    size === "md"
      ? "text-xs px-2.5 py-1 gap-1.5"
      : "text-[10px] px-2 py-0.5 gap-1";
  return (
    <span
      className={`inline-flex items-center rounded-full border font-semibold uppercase tracking-wider ${v.cls} ${sizing} ${className}`}
      data-testid={v.testid}
    >
      <Icon size={size === "md" ? 12 : 10} />
      {v.label}
    </span>
  );
}
